export const TABLE_NAMES = [
    "shot_records",
    "machine_status",
    "machine_events",
    "collection_gaps",
    "collector_heartbeat",
];
export const nodeId = {
    machine: (factoryId, machineId) => `machine:${factoryId}:${machineId}`,
    collector: (factoryId) => `collector:${factoryId}`,
    outbox: (factoryId) => `outbox:${factoryId}`,
    uploader: (factoryId) => `uploader:${factoryId}`,
    table: (name) => `table:${name}`,
    legacy: (factoryId) => `legacy:${factoryId}`,
    output: (name) => `output:${name}`,
};
export const OUTPUT_DASHBOARD = nodeId.output("dashboard");
export const OUTPUT_MONITOR = nodeId.output("monitor");
export function edgeId(source, target) {
    return `edge:${source}->${target}`;
}
/** "machine:vietnam:M01" → { factoryId, machineId } / 아니면 null. 공장 slug 는 서버가 정하므로 고정 목록을 두지 않는다. */
export function parseMachineNodeId(id) {
    const m = /^machine:([a-z0-9_-]+):(M\d+)$/.exec(id);
    if (!m)
        return null;
    return { factoryId: m[1], machineId: m[2] };
}
/** id 의 접두어("machine" | "collector" | ...) */
export function nodeKind(id) {
    return id.split(":")[0] ?? "";
}
